import store from "@/store";
import moment from "moment";

export const preparationSlipMappers = {
  mapAutoPrepSlip(data) {
    const mappedData = {
      ...data,
      quantity: Number(data.quantity),
      display_day: store.getters.getDayChoices.find(x => x.value === data.day)
        .text,
      display_created: moment(data.created).format("LLL")
    };
    return mappedData;
  },
  mapScheduledPrep(data) {
    const mappedData = {
      ...data,
      quantity: data.quantity !== null ? Number(data.quantity) : null
    };
    return mappedData;
  }
};
